import React, { useEffect } from "react";
import "./Checkout.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Radio, Grid, Row, Col } from "rsuite";
import { getCart, cartData } from "../../features/products/productSlice";
import BasketItem from "../Basket/BasketItem";
import Address from "../Address/Address";
import NewAddress from "../Address/NewAddress";
import Footer from "../Footer/Footer";
import {
  uid,
  customerAddresses,
  selectedAddress,
  getUserAddresses,
  selectAddress
} from "../../features/user/userSlice";
import { placeOrder } from "../../features/order/orderSlice";

/**
 * Custom hook that returns a function to handle saving the order
 *
 * @return {Function} Function that handles saving the order
 */
function useHandleSaveOrder() {
  const dispatch = useDispatch();
  const user = useSelector(uid);
  const address = useSelector(selectedAddress);

  const handleSaveOrder = (event, navigate) => {
    if (user) {
      event.preventDefault();
      dispatch(
        placeOrder({
          address
        })
      );
      navigate("/confirmation");
    } else {
      navigate("/login?redirect=/checkout");
    }
  };
  return handleSaveOrder;
}

/**
 * Component that displays the checkout page
 *
 * @return {JSX.Element} Checkout component JSX
 */
export default function Checkout() {
  const cartInfo = useSelector(cartData);
  const cartItems = cartInfo.items ? cartInfo.items : [];
  const totalCartPriceFinal = cartInfo.grandTotal;
  const totalCartPrice = cartInfo.subtotal ? cartInfo.subtotal : 0;
  const discountTotal = cartInfo.discountTotal;
  const CartShippingCharge = cartInfo.shippingCharge
    ? cartInfo.shippingCharge
    : 0;
  // const cartStatus = useSelector(getCartStatus);
  // const cartError = useSelector(getCartError);

  const addresses = useSelector(customerAddresses);
  const user = useSelector(uid);
  const showNewAddressOption = user && addresses.length === 0 ? true : false;

  const navigate = useNavigate();
  const handleSaveOrder = useHandleSaveOrder();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCart());
    dispatch(getUserAddresses());
  }, [dispatch]);

  useEffect(() => {
    // set first address as selected address
    if (addresses.length > 0) {
      dispatch(selectAddress(addresses[0]));
    }
  }, [dispatch, addresses]);

  return (
    <>
      <div className="checkout_container">
        <Grid fluid>
          <Row className="show-grid checkout_show_grid">
            <Col xs={24} sm={24} md={12}>
              <div className="checkout_container_left">
                <div className="checkout_box">
                  {showNewAddressOption ? (
                    <NewAddress />
                  ) : (
                    <div className="checkout_box_title">
                      <Address />
                    </div>
                  )}
                </div>
                <div className="checkout_box">
                  <div className="checkout_box_title">
                    <span className="checkout_subtitle">Payment Options</span>
                  </div>
                  <div className="checkout_confirm">
                    <Radio value="" checked>
                      Cash on Delivery
                    </Radio>
                  </div>
                  <button
                    className="basket_button_buy"
                    disabled={showNewAddressOption}
                    onClick={(event) => handleSaveOrder(event, navigate)}
                  >
                    {user && user != null ? "Place order" : "Login to proceed"}
                  </button>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <div className="checkout_container_right">
                {cartItems.length > 0 ? (
                  <div className="basket_container">
                    <div className="basket_itemBox">
                      <h5>Order Summary</h5>
                      <div className="checkout-total">
                        <span>Basket Value</span>
                        <span className="checkout-total-amount">
                          ₹{totalCartPrice.toLocaleString()}
                        </span>
                      </div>
                      <div className="checkout-total">
                        <span>Total Discount</span>
                        <span className="checkout-total-amount">
                          ₹{discountTotal.toLocaleString()}
                        </span>
                      </div>
                      <div className="checkout-total">
                        <span>Delivery Charge</span>
                        <span className="checkout-total-amount">
                          ₹{CartShippingCharge.toLocaleString()}
                        </span>
                      </div>
                      <span className="checkout-total-line"></span>
                      <div className="checkout-total">
                        <span>Total Amount Payable</span>
                        <span className="checkout-total-amount">
                          ₹{totalCartPriceFinal.toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="favorite_empty"></div>
                )}
              </div>
            </Col>
            <Col>
              <div className="basket-container">
                {cartItems.map((product) => (
                  <BasketItem key={product.id} {...product} />
                ))}
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
      <Footer tab={"checkout"} />
    </>
  );
}
